module.exports = __webpack_public_path__ + "media/img/description/description-automated-after-f4997882b3f9be5c06a1dc6c83befe07.svg";